import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

export const StyledSearchInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  .input {
    width: ${pxToVw(300)};
    .ant-input-affix-wrapper {
      border-right: none;
    }
    .ant-input-group-addon {
      background-color: white;
      .ant-btn {
        border: 1px solid #d9d9d9;
        border-left: none;
        border-top-right-radius: 20px !important;
        border-bottom-right-radius: 20px !important;
        transition: all 0.3s;
        .anticon {
          color: ${Colors.text};
        }
      }
    }
  }

  &:hover,
  &:focus-within {
    .ant-btn {
      border-color: ${Colors.primary} !important;
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    width: 100%;

    .input {
      width: 100%;
    }
  }
`;
